import { render, staticRenderFns } from "./lear_detail.vue?vue&type=template&id=5f860084&scoped=true"
import script from "./lear_detail.vue?vue&type=script&lang=js"
export * from "./lear_detail.vue?vue&type=script&lang=js"
import style0 from "./lear_detail.vue?vue&type=style&index=0&id=5f860084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f860084",
  null
  
)

export default component.exports